var _require = require('prettier/standalone'),
    _require$doc$builders = _require.doc.builders,
    concat = _require$doc$builders.concat,
    hardline = _require$doc$builders.hardline,
    indent = _require$doc$builders.indent,
    join = _require$doc$builders.join;

var AssemblySwitch = {
  print: function print(_ref) {
    var path = _ref.path,
        _print = _ref.print;
    var doc = join(hardline, path.map(_print, 'cases'));
    return concat(['switch ', path.call(_print, 'expression'), indent(hardline), indent(doc)]);
  }
};
module.exports = AssemblySwitch;